module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " m-t-0 w-1200",
    staticStyle: {
      "color": "#333"
    }
  }, [_c('span', {
    staticClass: "m-l-30",
    staticStyle: {
      "font-weight": "600",
      "color": "#00f"
    }
  }, [_vm._v("【配置名称】配置内容 描述：配置描述")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "m-t-10 padding-page",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "300px"
    }
  }, [_c('div', {
    staticClass: "form-pane"
  }, _vm._l((_vm.form.list), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": ' 【' + item.name + '】',
        "prop": "list"
      }
    }, [(item.config_type == 1 || item.config_type == 4) ? _c('el-input', {
      staticClass: "m-l-10 h-40 w-600",
      attrs: {
        "value": item.value
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.value"
      }
    }) : _vm._e(), _vm._v(" "), (item.config_type == 2) ? _c('el-radio-group', {
      staticClass: "m-l-10 h-40 w-600",
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.value"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("关闭")])], 1) : _vm._e(), _vm._v(" "), (item.config_type == 3) ? _c('div', {
      staticClass: "m-l-10 fl w-600"
    }, [_c('img', {
      staticClass: "fl m-r-10",
      staticStyle: {
        "width": "285px",
        "height": "160px",
        "cursor": "pointer",
        "background-color": "#aaa"
      },
      attrs: {
        "src": item.value
      },
      on: {
        "click": function($event) {
          return _vm.handlePictureCardPreview(item.value)
        }
      }
    }), _vm._v(" "), _c('el-upload', {
      attrs: {
        "action": _vm.uploadUrl,
        "type": "drag",
        "thumbnail-mode": true,
        "on-preview": _vm.viewPic,
        "on-remove": _vm.handleRemove,
        "on-success": function (response, file, fileList) {
          return _vm.uploadSuccess(response, file, fileList, item)
        },
        "on-error": _vm.uploadFail,
        "show-file-list": false
      }
    }, [_c('i', {
      staticClass: "el-icon-upload"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-dragger__text",
      on: {
        "click": function($event) {
          return _vm.set_upload(index)
        }
      }
    }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")]), _vm._v("  jpg/png文件")])])], 1) : _vm._e(), _vm._v("\n             描述："), _c('el-input', {
      staticClass: "m-l-10 h-40 w-400",
      attrs: {
        "value": item.remark
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.remark"
      }
    })], 1)
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "m-l-10 w-200",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "background-color": "#aaa"
    },
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加配置",
      "visible": _vm.dialogFormVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.formconfig,
      "label-width": "30%",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "配置名称",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：SET_NAME"
    },
    model: {
      value: (_vm.formconfig.name),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置描述",
      "prop": "remark",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：前端展示——平台名称"
    },
    model: {
      value: (_vm.formconfig.remark),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置内容",
      "prop": "value",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "例如：小程序，单选按钮填0或1"
    },
    model: {
      value: (_vm.formconfig.value),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formconfig.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "选择配置的展示类型"
    },
    model: {
      value: (_vm.formconfig.type),
      callback: function($$v) {
        _vm.$set(_vm.formconfig, "type", $$v)
      },
      expression: "formconfig.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "输入框",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "单选按钮",
      "value": 2
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.save('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cdb89b8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/website/website/add.vue
// module id = 1874
// module chunks = 2